<template>
  <div class="forum-background">
    <div class="forum-banner">
      <div class="forum-container">
        <div class="forum-banner-title">论坛</div>
      </div>

      <img class="forum-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="forum-container">

     <div class="forum-content">
       <div class="forum-content-title">
         <div class="forum-content-title-text">论坛服务</div>
       </div>
       <div class="forum-content-info">
         <p class="forum-content-info-text">“龙讯”除了给广大用户提供微信群方便交流（具体联系我们的销售经理和售前经理进入微信群），也在<a class="forum-a" href="http://bbs.keinsci.com/forum-105-1.html">计算化学公社-第一原理专区</a>提供论坛交流。我们的官方账号是“support@pwmat”。</p>
         <p class="forum-content-info-text">在PWmat版块您可以提出各种各样的问题：</p>
         <p class="forum-content-info-title-text"><i class="fa fa-tag forum-content-info-title-fa"></i>关于“龙讯”</p>
         <p class="forum-content-info-title-text"><i class="fa fa-tag forum-content-info-title-fa"></i>PWmat使用</p>
         <p class="forum-content-info-title-text"><i class="fa fa-tag forum-content-info-title-fa"></i>MSTATION使用</p>
         <p class="forum-content-info-title-text"><i class="fa fa-tag forum-content-info-title-fa"></i>材料模拟相关</p>
         <p class="forum-content-info-title-text"><i class="fa fa-tag forum-content-info-title-fa"></i>DFT理论相关</p>
         <p class="forum-content-info-title-text"><i class="fa fa-tag forum-content-info-title-fa"></i>高通量计算</p>
         <p class="forum-content-info-title-text"><i class="fa fa-tag forum-content-info-title-fa"></i>材料结构搜索</p>
         <p class="forum-content-info-title-text"><i class="fa fa-tag forum-content-info-title-fa"></i>材料计算算法研究</p>
         <p class="forum-content-info-title-text"><i class="fa fa-tag forum-content-info-title-fa"></i>......</p>
         <p class="forum-content-info-text">我们也会不定期在<a class="forum-a" @click="toCompanyNews">PWmat动态</a>页面展示一些论坛精华帖，也欢迎您对我们的网站内容提供各种意见和建议！</p>
       </div>

     </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ForumPage",
    methods:{
      toCompanyNews(){
        this.$router.push({ name: 'CompanyNews'})
      }
    }
  }
</script>

<style scoped>
  .forum-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .forum-background{
    margin-top: 70px;
  }
  .forum-banner{
    overflow:hidden;
  }
  .forum-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .forum-banner-img{
    min-width:100%;
    height:165px;
  }
  .forum-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .forum-content-title{
    padding-top: 50px;
    text-align: center;
  }
  .forum-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .forum-content-info{
    margin-top: 50px;
  }
  .forum-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .forum-a{
    color:rgba(73,145,201,1)!important;
    cursor: pointer;
  }
  .forum-a:hover,
  .forum-a:active,
  .forum-a:focus{
    text-decoration: underline !important;
  }
  .forum-content-info-title-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight: bolder;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .forum-content-info-title-fa{
    font-size: 16px;
    padding-right: 8px;
  }
  @media screen and (max-width:482px) {
    .forum-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .forum-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .forum-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .forum-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .forum-container{
      max-width: 1068px;
    }
  }

</style>